import FadeIn from './FadeIn';

const genres = ['Afro House', 'Afro Tech', 'Deep House', 'Soulful House', 'Amapiano', 'Gqom'];

const textures = [
  'Percussive & hypnotic',
  'Warm low-end presence',
  'Jazz sensitivity',
  'Spiritual tension',
  'Emotionally cinematic',
  'Rhythm-led storytelling',
  'Futuristic, but human',
];

export default function Sonic() {
  return (
    <section id="sonic" data-testid="sonic-section">
      <div className="section-inner">
        <FadeIn>
          <div className="section-label">04 — Sonic World</div>
        </FadeIn>
        <div className="sonic-grid">
          <FadeIn>
            <h3 className="sonic-heading">Genre Territory</h3>
            <div className="genre-tags">
              {genres.map((g) => (
                <span key={g} className="genre-tag">{g}</span>
              ))}
            </div>
            <h3 className="sonic-heading" style={{ marginTop: '2.5rem' }}>Sound Texture</h3>
            <ul className="descriptor-list">
              {textures.map((t) => (
                <li key={t}>{t}</li>
              ))}
            </ul>
          </FadeIn>
          <FadeIn delay={0.15}>
            <blockquote className="sonic-statement" data-testid="sonic-quote">
              "The township didn't give me instruments. It gave me ears — tuned to improvisation,
              to rhythm found in everything, to beauty made from what's available."
            </blockquote>
            <p className="sonic-text">
              Lulo Lonke's sound is not simply a genre selection. It is the accumulation of a
              life spent listening — to jazz through carwash walls, to underground house in
              basement clubs, to the pulse of cities across three continents. The result is
              music that moves bodies and stirs memory simultaneously.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
